import React from "react";
import styled from "styled-components";

const Link = styled.a`
    color: white;
    background-color: #bd2130;
    text-align: center;
    padding: 10px;
    border-radius: 3px;
    width: 100%;
    display: inline-block;

    &:hover {
        color: white;
        text-decoration: none;
    }
`;

const ClearRockButton = () => {

    return (
        <Link href="/" className="button">Clear</Link>
    );
};

export default ClearRockButton;